import { Box, Typography } from "@mui/material";

interface Props {
  subtotalLabelFormatPrefix: string;
  subtotalLabelFormatSuffix: string;
  isDisabled: boolean;
}

const SubtotalLabelFormatPreview = ({ subtotalLabelFormatPrefix, subtotalLabelFormatSuffix, isDisabled }: Props) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, opacity: isDisabled ? 0.5 : 1 }}>
      <Typography variant="caption" color="textSecondary">
        Preview:
      </Typography>
      <Typography variant="caption" sx={{ lineBreak: "anywhere" }}>
        {subtotalLabelFormatPrefix}
        <Typography component="span" variant="caption" noWrap sx={{ mx: 0.3 }}>
          [Group Name]
        </Typography>
        {subtotalLabelFormatSuffix}
      </Typography>
    </Box>
  );
};

export default SubtotalLabelFormatPreview;
